<template lang="html">
  <div class="choose-city-wrapper">
    <city v-on:selectCity="getCity" wrapper="actionsheet-bd"></city>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import city from '@/components/selectAddress/city'

export default {
  components: {
    city
  },
  computed: {
    // ...mapState(['confirmProduct', 'selectedWorker']),
  },
  methods: {
    getCity(item) {
      this.$store.commit('setServerCity', item)
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.choose-city-wrapper {
  min-height: 100%;
  background: #f4f4f4;
}
</style>
